import { Colors } from "../constants/colors";
import { FONT_FAMILIES } from "./styles";
import { getRGBColorByHex } from "../services/colorsService";

export default {
  styleOverrides: {
    root: {
      ...FONT_FAMILIES.LIGHT,
      boxShadow: "0px 0px 0px 1px rgba(196, 196, 205, 0.25)",
      borderRadius: "4px",
      border: "none",
      fontSize: "12px",
      lineHeight: "24px",
      textTransform: "none",
      color: Colors.WHITE,
      padding: "8px 9px",
      "&.MuiToggleButton-sizeSmall": {
        lineHeight: "12px",
      },
      "&.MuiToggleButton-sizeMedium": {
        lineHeight: "17px",
      },
      "&:disabled": {
        color: Colors.WHITE
      }
    },
  },
  variants: [
    {
      props: { variant: "default" },
      style: {
        background: getRGBColorByHex(Colors.WHITE, 0.2),
        "&:hover": {
          background: Colors.GREY480,
        },
        color: Colors.WHITE,
      },
    },
    {
      props: { variant: "default", noHover: true },
      style: {
        background: getRGBColorByHex(Colors.WHITE, 0.2),
        "&:hover": {
          background: getRGBColorByHex(Colors.WHITE, 0.2),
        },
        color: Colors.WHITE,
      },
    },
    {
      props: { variant: "selected" },
      style: {
        background: Colors.WHITE,
        color: Colors.BLACK,
        "&:hover": {
          background: Colors.WHITE,
        },
      },
    },
    {
      props: { variant: "dark" },
      style: {
        background: "rgba(116, 116, 128, 0.2)",
        boxShadow: "none",
        "&:hover": {
          background: Colors.GREY400,
        },
        color: Colors.GREY200,
      },
    },
    {
      props: { variant: "dark", noHover: true },
      style: {
        background: "rgba(116, 116, 128, 0.2)",
        boxShadow: "none",
        "&:hover": {
          background: "rgba(116, 116, 128, 0.2)",
        },
        color: Colors.GREY200,
      },
    },
  ],
};
